import { create } from "zustand";
import { ViewWLSubscriptionsTiers } from "../../../../Common/models/subscriptions";
interface PurchaseV2State {
  createAndPayPowerUpInvoice: () => void;
  setCreateAndPayPowerUpInvoiceFunc: (func: () => void) => void;

  createAndPaySubscriptionInvoice: () => void;
  setCreateAndPaySubscriptionInvoiceFunc: (func: () => void) => void;

  createAndPayDowngradeInvoice: () => void;
  setCreateAndPayDowngradeInvoiceFunc: (func: () => void) => void;

  createAndPayUpgradeInvoice: () => void;
  setCreateAndPayUpgradeInvoiceFunc: (func: () => void) => void;

  createAndRetryPaymentInvoice: () => void;
  setCreateAndRetryPaymentInvoiceFunc: (func: () => void) => void;

  selectedProduct: undefined | ViewWLSubscriptionsTiers;
  setSelectedProduct: (state: undefined | ViewWLSubscriptionsTiers) => void;

  doubleForHalfOffAvailed: boolean;
  setDoubleForHalfOffAvailed: (state: boolean) => void;

  showStripePaymentMethod: boolean;
  setShowStripePaymentMethod: (state: boolean) => void;

  oneTimeOffer: boolean;
  setOneTimeOffer: (state: boolean) => void;

  error: string;
  setError: (state: string) => void;

  reset: () => void;
}

export const usePurchaseV2Store = create<PurchaseV2State>((set) => ({
  selectedProduct: undefined,
  setSelectedProduct: (selectedProduct) => set({ selectedProduct }),

  createAndPayPowerUpInvoice: () => {},
  setCreateAndPayPowerUpInvoiceFunc: (createAndPayPowerUpInvoice) =>
    set({ createAndPayPowerUpInvoice }),

  createAndPaySubscriptionInvoice: () => {},
  setCreateAndPaySubscriptionInvoiceFunc: (createAndPaySubscriptionInvoice) =>
    set({ createAndPaySubscriptionInvoice }),

  createAndPayDowngradeInvoice: () => {},
  setCreateAndPayDowngradeInvoiceFunc: (createAndPayDowngradeInvoice) =>
    set({ createAndPayDowngradeInvoice }),

  createAndPayUpgradeInvoice: () => {},
  setCreateAndPayUpgradeInvoiceFunc: (createAndPayUpgradeInvoice) =>
    set({ createAndPayUpgradeInvoice }),

  createAndRetryPaymentInvoice: () => {},
  setCreateAndRetryPaymentInvoiceFunc: (createAndRetryPaymentInvoice) =>
    set({ createAndRetryPaymentInvoice }),

  doubleForHalfOffAvailed: false,
  setDoubleForHalfOffAvailed: (doubleForHalfOffAvailed) =>
    set({ doubleForHalfOffAvailed }),

  showStripePaymentMethod: false,
  setShowStripePaymentMethod: (showStripePaymentMethod) =>
    set({ showStripePaymentMethod }),

  oneTimeOffer: false,
  setOneTimeOffer: (oneTimeOffer) => set({ oneTimeOffer }),

  error: "",
  setError: (error) => set({ error }),

  reset: () =>
    set({
      selectedProduct: undefined,
      createAndPayPowerUpInvoice: () => {},
      createAndPaySubscriptionInvoice: () => {},
      createAndPayDowngradeInvoice: () => {},
      createAndPayUpgradeInvoice: () => {},
      createAndRetryPaymentInvoice: () => {},
      doubleForHalfOffAvailed: false,
      showStripePaymentMethod: false,
      oneTimeOffer: false,
      error: "",
    }),
}));
